import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Container, Typography, Button, Box, Alert } from '@mui/material'
import { Route } from '../../../router'
import SplashScreenGuard from '../../../router/guards/SplashScreenGuard'
import LocalStorageKeys from '../../../types/LocalStorageKeys'
import useTrackPageView from '../../../helpers/hooks/use-track-page-view'

import styles from './ThankYouPage.module.scss'

const ThankYouPage = () => {
    useTrackPageView(`Undertaking Form Thank You Page`)

    const navigate = useNavigate()
    const [hasAgreed, setHasAgreed] = useState<boolean>(false)

    useEffect(() => {
        setHasAgreed(localStorage.getItem(LocalStorageKeys.UNDERTAKING_FORM_HAS_AGREED) === `true`)
    }, [])

    const handleGoHome = () => {
        navigate(Route.HOME)
    }

    return (
        <SplashScreenGuard>
            <Container className={styles.container}>
                <Box className={styles.iconContainer}>
                    <Box className={styles.checkIcon}>✓</Box>
                </Box>

                <Typography variant="h3" className={styles.title}>
                    Thank You!
                </Typography>

                {hasAgreed ? (
                    <>
                        <Typography variant="body1" className={styles.message}>
                            Thank you for confirming your agreement to transition from NTUC Starter
                            membership to NTUC membership.
                        </Typography>

                        <Box className={styles.nextSteps}>
                            <Typography variant="h6" className={styles.nextStepsTitle}>
                                What happens next:
                            </Typography>
                            <Typography className={styles.stepsList}>
                                Hang tight - you&apos;ll be able to access your NTUC Membership from 15 April 2026 onwards!
                            </Typography>
                            <Typography className={styles.stepsList}>
                                In the meantime, stay connected with NTUC Youth on our social media to be in the loop for any upcoming events. See you there!
                            </Typography>
                        </Box>
                    </>
                ) : (
                    <>
                        <Typography variant="body1" className={styles.message}>
                            Thank you for your response. We have received your decision to
                            not transition to NTUC membership.
                        </Typography>

                        <Alert severity="info" className={styles.refundAlert}>
                            <Typography variant="body1" className={styles.refundAmount}>
                                You will remain an active Starter member until 31 Dec 2026 or your renewal date this year (whichever is earlier) and will not be charged for any renewals. Do refer to updates to Starter Membership in your confirmation email for more details.
                            </Typography>
                            <Typography variant="body1" className={styles.refundAmount}>
                                Remember to stay connected with NTUC Youth for further updates!
                            </Typography>
                        </Alert>
                    </>
                )}

                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleGoHome}
                    className={styles.homeButton}
                    fullWidth
                >
                    Return to Homepage
                </Button>
            </Container>
        </SplashScreenGuard>
    )
}

export default ThankYouPage
